import { apiRequest, apiUpload } from './httpClient';

export function register({ fullName, email, password, preferredLanguage }) {
  return apiRequest('/api/auth/register', {
    method: 'POST',
    body: {
      full_name: fullName,
      email,
      password,
      preferred_language: preferredLanguage || 'en',
    },
  });
}

export function login({ email, password, rememberMe }) {
  return apiRequest('/api/auth/login', {
    method: 'POST',
    body: { email, password, remember_me: !!rememberMe },
  });
}

// The `credential` is the ID token Google Identity Services handed the
// browser. Sent as-is and never inspected here - it only means anything
// once the backend has verified its signature.
export function googleSignIn({ credential }) {
  return apiRequest('/api/auth/google', {
    method: 'POST',
    body: { credential },
  });
}

// Completes a password signup. On success the backend sets the auth
// cookies, so this establishes the session exactly as login does.
export function verifyEmail({ email, code }) {
  return apiRequest('/api/auth/verify-email', {
    method: 'POST',
    body: { email, code },
  });
}

export function resendVerification({ email }) {
  return apiRequest('/api/auth/resend-verification', {
    method: 'POST',
    body: { email },
  });
}

export function logout() {
  return apiRequest('/api/auth/logout', { method: 'POST' });
}

export function fetchMe() {
  return apiRequest('/api/auth/me');
}

export function forgotPassword({ email }) {
  return apiRequest('/api/auth/forgot-password', {
    method: 'POST',
    body: { email },
  });
}

export function resetPassword({ token, newPassword }) {
  return apiRequest('/api/auth/reset-password', {
    method: 'POST',
    body: { token, new_password: newPassword },
  });
}

export function updateProfile(payload) {
  return apiRequest('/api/users/me', { method: 'PATCH', body: payload });
}

export function uploadAvatar(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiUpload('/api/users/me/avatar', formData);
}

export function updatePreferences(preferences) {
  return apiRequest('/api/users/me/preferences', {
    method: 'PATCH',
    body: { preferences },
  });
}

export function changePassword({ oldPassword, newPassword }) {
  return apiRequest('/api/users/me/change-password', {
    method: 'POST',
    body: { old_password: oldPassword, new_password: newPassword },
  });
}

export function logoutAllDevices() {
  return apiRequest('/api/users/me/logout-all', { method: 'POST' });
}

// Which confirmation the backend requires depends on the account: a
// password account re-enters its password, a Google account types its
// email address. Both are sent and the server decides - it reads
// has_password from the row rather than trusting which field arrived.
export function deleteAccount({ password, confirmEmail, reason } = {}) {
  return apiRequest('/api/users/me/delete', {
    method: 'POST',
    body: {
      password: password || null,
      confirm_email: confirmEmail || null,
      reason: reason || null,
    },
  });
}
